var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Banner } from "common";
import { Footer, MainNav, SkipLink } from "core/components";
import { mq } from "core/styles/snippets";
import { Result, graphql } from "core/utils";
import gql from "graphql-tag";
import React, { useState } from "react";
import { Search } from "search";
import styled, { css } from "styled-components";
import { PlayerContext } from "./PlayerContext";
import { SearchContext } from "./SearchContext";
export var GET_NAVCONFIG = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetNavConfig {\n    navConfig @client\n  }\n"], ["\n  query GetNavConfig {\n    navConfig @client\n  }\n"])));
var BottomNav = function () {
    var result = graphql.useQueryWithResult(GET_NAVCONFIG).result;
    if (!Result.isSuccess(result))
        return null;
    var navConfig = result.value.navConfig;
    return navConfig.isShown && !navConfig.hideFooter ? React.createElement(Footer, null) : null;
};
var getShowNav = function () {
    var result = graphql.useQueryWithResult(GET_NAVCONFIG).result;
    if (!Result.isSuccess(result))
        return true;
    var navConfig = result.value.navConfig;
    return navConfig.isShown;
};
export var Nav = function (_a) {
    var children = _a.children;
    var _b = useState(null), player = _b[0], setPlayer = _b[1];
    var _c = useState(false), autoPaused = _c[0], setAutoPaused = _c[1];
    var _d = useState(false), showSearch = _d[0], setShowSearch = _d[1];
    var _e = useState(""), initialSearchTerm = _e[0], setInitialSearchTerm = _e[1];
    var result = graphql.useQueryWithResult(GET_NAVCONFIG).result;
    var hideFooter = Result.isSuccess(result) && result.value.navConfig.hideFooter;
    var showNav = getShowNav();
    return (React.createElement(PlayerContext.Provider, { value: { player: player, setPlayer: setPlayer, autoPaused: autoPaused, setAutoPaused: setAutoPaused } },
        React.createElement(SearchContext.Provider, { value: { showSearch: showSearch, setShowSearch: setShowSearch, initialSearchTerm: initialSearchTerm, setInitialSearchTerm: setInitialSearchTerm } },
            React.createElement(Wrapper, null,
                React.createElement(SkipLink, { href: "#main-content" }, "Skip naar content"),
                React.createElement(Banner, null),
                React.createElement(InnerWrapper, null,
                    showNav ? (React.createElement(React.Fragment, null,
                        React.createElement(MainNav, null))) : null,
                    React.createElement(FlexWrap, { "$hideNav": !showNav, "$hideFooter": hideFooter },
                        React.createElement(Container, { id: "main-content" },
                            " ",
                            children),
                        React.createElement(BottomNav, null)),
                    React.createElement(Search, null))))));
};
var InnerWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var Wrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 0;\n  margin: 0;\n"], ["\n  padding: 0;\n  margin: 0;\n"])));
var FlexWrap = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-top: 3.75rem; // because of fixed header height\n  display: flex;\n  flex-direction: column;\n\n  ", "\n\n  ", "\n\n  ", " {\n    margin-top: 5rem; // because of fixed header height\n  }\n\n  ", " {\n    margin-top: 6.25rem; // because of fixed header height\n  }\n\n  ", " {\n    margin-top: 6.375rem; // because of fixed header height\n  }\n"], ["\n  margin-top: 3.75rem; // because of fixed header height\n  display: flex;\n  flex-direction: column;\n\n  ", "\n\n  ", "\n\n  ", " {\n    margin-top: 5rem; // because of fixed header height\n  }\n\n  ", " {\n    margin-top: 6.25rem; // because of fixed header height\n  }\n\n  ", " {\n    margin-top: 6.375rem; // because of fixed header height\n  }\n"])), function (props) {
    return props.$hideNav && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      margin-top: 0 !important;\n    "], ["\n      margin-top: 0 !important;\n    "])));
}, function (props) {
    return !props.$hideFooter && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      min-height: calc(100vh - 5rem);\n    "], ["\n      min-height: calc(100vh - 5rem);\n    "])));
}, mq.minWidth("48rem"), mq.minWidth("90rem"), mq.minWidth("120rem"));
var Container = styled.main(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n"], ["\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
